import { Button, Label, Layout, Textbox, Tree, } from "@mcleod/components";

export abstract class AutogenLayoutModelTester extends Layout {
    buttonExecute: Button;
    labelCount: Label;
    textModel: Textbox;
    textParams: Textbox;
    treeResults: Tree;
}
